import React, {useState} from "react";
import {usePackagesStyles} from "./useStyles";
import {Grid, Typography} from "@material-ui/core";
import PackageItem from "./PackageItem";
import {useSelector} from "react-redux";
import PackageItemSkeleton from "./PackageItemSkeleton";

const PRICING_MONTHLY = 'MONTHLY';
const PRICING_YEARLY = 'YEARLY';
const PRICING_CUSTOM = 'CUSTOM';

const PRICING_TYPE_MONTHLY = 'monthly';
const PRICING_TYPE_YEARLY = 'yearly';
const PRICING_TYPE_CUSTOM = 'custom';

const Packages = () => {
    const {packages, agencyName, agencyLogo} = useSelector((state)=> (state.signupReducer));
    const [loading, setLoading] = useState(false);
    const [priceType, setPriceType] = useState('yearly');

    const filteredPlans = () => {
        try{
            const filteredPlans = [];

            packages.forEach(plan => {
                const pricing = JSON.parse(plan.pricing);
                const view_features = JSON.parse(plan.view_features);

                pricing.forEach(price => {
                    const description = (plan.max_sub_user === null && plan.price_for_subuser === 0) ? 'Unlimited Users' : (plan.max_sub_user > 0 ? `Up to ${plan.max_sub_user + 1} Users` : 'Ideal for Individual Use');

                    if (priceType === PRICING_TYPE_MONTHLY && price.name === PRICING_MONTHLY && price.price !== null) {
                        filteredPlans.push({
                            plan_id: plan.id,
                            title: plan.name,
                            features: view_features,
                            price_id: price.id,
                            price: price.price,
                            stripe_price_id: price.stripe_price_id,
                            validity: price.validity,
                            description: description,
                            custom: false,
                            trial_period: plan.trial_period
                        });
                    } else if (priceType === PRICING_TYPE_YEARLY && price.name === PRICING_YEARLY && price.price !== null) {
                        filteredPlans.push({
                            plan_id: plan.id,
                            title: plan.name,
                            features: view_features,
                            price_id: price.id,
                            price: price.price,
                            stripe_price_id: price.stripe_price_id,
                            validity: price.validity,
                            description: description,
                            custom: false,
                            trial_period: plan.trial_period
                        });
                    } else if (priceType === PRICING_TYPE_CUSTOM && price.name === PRICING_CUSTOM && price.price !== null) {
                        filteredPlans.push({
                            plan_id: plan.id,
                            title: plan.name,
                            features: view_features,
                            price_id: price.id,
                            price: price.price,
                            stripe_price_id: price.stripe_price_id,
                            validity: price.validity,
                            description: description,
                            custom: false,
                            price_type: price.name,
                            trial_period: plan.trial_period
                        });
                    }
                });
            });

            return filteredPlans;
        }catch (err){
            return [];
        }
    };

    const hasCustom = packages.some(plan => {
        const pricing = JSON.parse(plan.pricing);

        return pricing.some(price =>
            price.name === PRICING_CUSTOM &&
            price.price !== null
        );
    });

    const handleToggle = (type) => {
        setPriceType(type);
    };

    const classes = usePackagesStyles({
        hasCustom: hasCustom
    });

    return(
        <div className={classes.paper}>
            <div className={classes.paperHeader}>
                <div className={classes.companyLogo}>
                    <img
                        src={agencyLogo}
                        alt={agencyName}
                    />
                </div>

                <div className={classes.headerText}>
                    <Typography variant={'h3'} style={{ height: 'unset !important' }}>
                        Choose the Right Plan for Your Business
                    </Typography>

                    <Typography variant={'h4'} style={{ height: 'unset !important' }}>
                        Whether you're a small team or scaling across departments, our flexible plans are designed to support your growth with robust features and unmatched reliability.
                    </Typography>
                </div>
            </div>

            <div className={classes.toggleContainer}>
                <Typography
                    className={`${classes.toggleOption} ${priceType === 'monthly' ? 'active' : ''}`}
                    onClick={() => { handleToggle('monthly'); }}
                    style={{ height: 'unset !important' }}
                >
                    Monthly
                </Typography>
                <Typography
                    className={`${classes.toggleOption} ${priceType === 'yearly' ? 'active' : ''}`}
                    onClick={() => { handleToggle('yearly'); }}
                    style={{ height: 'unset !important' }}
                >
                    Annual
                </Typography>

                {
                    hasCustom &&
                    <Typography
                        className={`${classes.toggleOption} ${priceType === 'custom' ? 'active' : ''}`}
                        onClick={() => { handleToggle('custom'); }}
                        style={{ height: 'unset !important' }}
                    >
                        Custom
                    </Typography>
                }
                <div className={`${classes.toggleSlider} ${ priceType }`}/>
            </div>

            <div className={classes.gridContainer}>
                {
                    loading ?
                        Array(5)
                        .fill(1)
                        .map((_, index) => (
                            <PackageItemSkeleton key={index}/>
                        )) :
                        <Grid container spacing={3} wrap="nowrap" className={classes.cardContainer}>
                            {
                                filteredPlans()
                                .map((plan, index) => (
                                    <PackageItem
                                        plan={plan}
                                        key={index}
                                    />
                                ))
                            }
                        </Grid>
                }
            </div>
        </div>
    );
};

export default Packages;